// extracted by mini-css-extract-plugin
export default {"checkbox_group":"MapSetting_checkbox_group__pvofo","radio_group":"MapSetting_radio_group__hjZw2"};